import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { PERMISSION, RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { cloneData, isArray, isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { mapInfoView } from 'src/app/helper/interface/form-interface';
import { tabSegment } from 'src/app/helper/interface/menu-interface';
import { ResponseData } from 'src/app/helper/interface/response';
import { AuthService } from 'src/app/helper/service/auth.service';
import { StaffApiService } from 'src/app/modules/staff/service/staff-api.service';

@Component({
  selector: 'app-staff-basic',
  templateUrl: './staff-basic.component.html',
  styleUrls: ['./staff-basic.component.scss'],
})
export class StaffBasicComponent implements OnInit {
  staffData: any = {};
  public onClose: Subject<boolean> = new Subject();
  isDeleted: boolean = false;
  isRestore: boolean = false;
  isModifyRequest: boolean = true;
  isModal: boolean = false;
  spouseDetail: any = {};
  STATUS = [{ name: 'Active', id: 1 }, { name: 'In Active ', id: 0 }];
  loadingData: boolean = false;
  mode: 'STAFF' | 'FAMILY' | 'PAYROLL' = 'STAFF';
  showTab: boolean = false;
  segment: tabSegment = {
    BASIC: { title: 'Basic' },
    ALLOTMENT: { title: 'Allotment' },
    PAYROLL: { title: 'Payroll' }
  }
  showData: mapInfoView[] = [{ name: 'name' }, { name: 'regionName', title: 'Region' }, { name: 'zoneName', title: 'Zone' }, { name: 'fieldName', title: 'Field' }, { title: 'Department', name: 'dName' },
  { title: 'Date of Birth', name: 'dob', type: 'DATE' }, { title: 'Gender', name: 'genderName' }, { title: 'Mobile No', name: 'mobile_no' }, { title: 'Branch', name: 'branchName' },
  { title: 'E-mail', name: 'email_id' }, { title: 'Blood Group', name: 'blood_groupName' }, { title: 'GSHA', name: 'gsha' }, { title: 'Cross Ref', name: 'staff_cross_id', type: 'INFO' }, { title: 'MS Office', name: 'adName' }, { title: 'Active From', name: 'do_join', type: 'DATE' }, { title: 'Remarks', name: 'reason_relive' },
  { title: 'Status', name: 'statusName' }, { title: 'Last Update', name: 'updated_at', type: 'DATETIME' }, { title: 'Relived Date', type: 'DATE', name: 'deleted_at', hideIfEmpty: true }
  ]
  showPayRoll: boolean = false;
  spouseInfoView: mapInfoView[] = cloneData(this.showData);
  @ViewChild('container') container !: ViewContainerRef;
  constructor(
    private _bsModalRef: BsModalRef,
    private staffApi: StaffApiService,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.showTab = this.auth.checkPermission('STAFF', 'VIEW_SPONSORSHIP');
    this.showPayRoll = this.auth.checkPermission('STAFF', 'MANAGE_PAYROLL') || this.auth.checkPermission('STAFF', 'VERIFY') || this.auth.checkPermission('PAYROLL', 'PROCESS') || this.auth.checkPermission('PAYROLL', 'VERIFY') || this.auth.checkPermission('PAYROLL', 'APPROVE');
    if (!this.showTab) {
      //@ts-ignore
      delete this.segment.ALLOTMENT;
    }
    if (!this.showPayRoll) {
      //@ts-ignore
      delete this.segment.PAYROLL;
    }
  }

  setInput(data: any) {
    this.isModal = true;
    this.mode = data.mode || 'STAFF';
    if (data.action_id) {
      if (+data.action_id == PERMISSION.DELETE) {
        this.isDeleted = true;
      }
      this.isModifyRequest = true;
      this.staffData = data.request_data || {};
    }
    if (isEmptyObj(this.staffData)) {
      if (data.staffData) {
        this.staffData = data.staffData;
      } else
        this.getData(data.staff_emp_id || '', data.staff_cross_id || '');
    }
  }
  payrollData = {}
  getData(id: string | number, cross_ref = '') {
    if (id || cross_ref) {
      this.loadingData = true;
      let api: any;
      if (this.mode == 'STAFF') {
        api = this.staffApi.getBasic(id, false);
      } else if (this.mode == 'PAYROLL') {
        api = this.staffApi.getStaffPayroll(id);
      } else {
        api = cross_ref ? this.staffApi.getStaffByCross(cross_ref) : this.staffApi.getFamilyByStaff(id);
      }
      api.then((res: ResponseData | any) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          if (isArray(res.result)) {
            this.staffData = res.result[0];
            this.spouseDetail = res.result[1] || {};
          } else if (!isEmptyObj(res.result)) {
            this.staffData = res.result;
            this.payrollData = this.staffData?.payroll || null
            this.spouseDetail = res.result.spouse || {};
          }
          this.staffData.statusName = this.staffData.deleted_at ? 'In Active' : 'Active';
          if (!isEmptyObj(this.spouseDetail)) {
            // this.staffData.profile_img_path = this.staffData.family_img_path;
            this.spouseDetail.statusName = this.spouseDetail.deleted_at ? 'In Active' : 'Active';
            this.spouseInfoView[0].name = 'fullName';
            this.spouseInfoView[0].title = ' Name ';
            this.spouseInfoView[1].name = 'staff_cross_id';
            this.spouseInfoView[1].title = ' Cross Ref ';
          }

        }
      }).finally(() => {
        this.loadingData = false;
      })
    }
  }

  close(status = false) {
    this._bsModalRef.hide();
    this.onClose.next(status);
  }
}